export class RebatePaymentMethodDto {
  id: number;
  name: string;
}